<template>
    <v-card>
        <v-card-title class="text-center">
            <h2>{{ type }}s</h2>
        </v-card-title>
        <v-card-text>
            <v-btn v-if="can_add" color="primary" class="w-100 text-white" prepend-icon="mdi-plus-circle"
                @click="showAddItemModal = true; isActiveDialog = true;">
            </v-btn>
            <Item v-for="item in items" :key="item.id" :item="item" :type="type" :item_general_info="item_general_info"
                :item_additional_info="item_additional_info" :can_show="can_show" :can_edit="can_edit"
                :can_add_csv="can_add_csv" :can_delete="can_delete" @csv="user_to_manage = item; $refs.csv_file.click()"
                @edit="user_to_manage = item; showEditItemModal = true; isActiveDialog = true;"
                @delete="user_to_manage = item; showDeleteItemModal = true; isActiveDialog = true;" />
            <GeneralForm :type="`add${type}`" v-if="showAddItemModal && isActiveDialog"
                v-model:isActiveDialog="isActiveDialog" @formComplete="$emit('add', $event)"
                @close="showAddItemModal = false; isActiveDialog = true;" />
            <GeneralForm :type="`edit${type}`" v-if="showEditItemModal && isActiveDialog" :data="user_to_manage"
                v-model:isActiveDialog="isActiveDialog" @formComplete="$emit('edit', $event)"
                @close="showEditItemModal = false; isActiveDialog = false;" />
            <GeneralConfirmModal v-if="showDeleteItemModal && isActiveDialog" :type="`delete${type}`"
                :validation_text="user_to_manage[validation_target]" v-model:isActiveDialog="isActiveDialog"
                @formComplete="$emit('delete', user_to_manage)"
                @close="showDeleteItemModal = false; isActiveDialog = false;" />
            <input type="file" ref="csv_file" style="display: none" @change="uploadCSV">
        </v-card-text>
    </v-card>

</template>
<style lang="stylus" scoped>
@import("../../../assets/css/generalColors.styl")

#ItemListCard
    background-color rgba(255,255,255,.6)
    border-radius 8px
    padding 15px
    display flex
    flex-direction column


    @media (max-width: 500px)
        border-radius 0

        svg 
            height 45px
            width 45px
            color main-color

        &:hover
            background-color main-color
        
        svg
            color third-color
</style>
<script>
import Item from './GeneralListItem'
import GeneralForm from '@/components/admin/forms/GeneralForm.vue'
import GeneralConfirmModal from '@/components/admin/forms/ConfirmForm.vue'

export default {
    name: 'ItemList',
    components: {
        Item,
        GeneralForm,
        GeneralConfirmModal,
    },
    props: [
        'items',
        'type',
        'validation_target',
        'can_show',
        'can_add',
        'can_edit',
        'can_delete',
        'can_add_csv',
        'item_additional_info',
        'item_general_info'
    ],
    beforeMount() {
        this.canAdd = true
    },
    data() {
        return {
            canAdd: false,
            showAddItemModal: false,
            showEditItemModal: false,
            showDeleteItemModal: false,
            user_to_manage: false,
            isActiveDialog: false
        }
    },
    methods: {
        uploadCSV: function (event) {
            const files = event.target.files;

            if (files.length == 1) {
                this.$emit('uploadCSV', {
                    vehicle_id: this.user_to_manage.id,
                    file: files[0]
                })
            }

        }
    },
}
</script>